import { CardAPI, computed, debug, observable } from "aaa";
import { action } from "mobx";
import { ISigningInfo } from "types/signing";
import { CardAPIClient } from "../../network/APIClient";
import { IGetGooglePayApprovalResponse } from "types/googlePay";

export class GooglePayStore {
    @observable approvalResponse?: IGetGooglePayApprovalResponse;
    @observable signInfo?: ISigningInfo;

    // Needed only for platforms using PdfViewer component for rendering (currently only Android)
    pdfData?: Uint8Array;

    @observable _isLoading = true;

    @computed get isLoading() {
        return this._isLoading;
    }

    @action async loadData() {
        try {
            this._isLoading = true;

            await this.getGooglePayApproval();

            this._isLoading = false;
        } catch (error) {
            debug.log("[GooglePayStore] loadData error:", error);

            throw error;
        }
    }

    @action async getGooglePayApproval() {
        try {
            this._isLoading = true;

            const response = await CardAPIClient.requestType(CardAPI.getGooglePayApproval());

            this.approvalResponse = response;

            this._isLoading = false;
        } catch (error) {
            this._isLoading = false;
            throw error;
        }
    }

    @action async postGooglePayApproval() {
        try {
            this._isLoading = true;

            const response = await CardAPIClient.requestType(CardAPI.postGooglePayApproval());

            this.signInfo = response.signInfo;

            this._isLoading = false;
        } catch (error) {
            this._isLoading = false;
            throw error;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/googlePay/GooglePayStore.ts